import { getTargetElementProps } from '../util';
import { getBrowserProps, getPageviewPropsForClick, } from '../util/getPageviewProps';
export const activityTrackerEvents = Object.entries({
    click: (e, logger) => {
        void logger.log({
            eventName: 'CLICK',
            logData: Object.assign(Object.assign({}, getPageviewPropsForClick()), { targetElement: getTargetElementProps(e), x: e.x, y: e.y }),
        });
    },
    submit: (e, logger) => {
        const formFields = [];
        for (let i = 0; i < e.target.elements.length; i++) {
            const element = e.target.elements.item(i);
            if (element !== e.submitter) {
                formFields.push({
                    name: element === null || element === void 0 ? void 0 : element.name,
                    type: element === null || element === void 0 ? void 0 : element.type,
                    value: element === null || element === void 0 ? void 0 : element.value,
                    id: element === null || element === void 0 ? void 0 : element.id,
                    class: element === null || element === void 0 ? void 0 : element.className,
                });
            }
        }
        void logger.log({
            eventName: 'FORM_SUBMIT',
            logData: Object.assign(Object.assign({}, getBrowserProps()), { targetElement: getTargetElementProps(e), formFields }),
        });
    },
    change: (e, logger) => {
        var _a, _b;
        void logger.log({
            eventName: 'INPUT_CHANGE',
            logData: Object.assign(Object.assign({}, getBrowserProps()), { targetElement: getTargetElementProps(e), name: (_a = e.target) === null || _a === void 0 ? void 0 : _a.name, value: (_b = e.target) === null || _b === void 0 ? void 0 : _b.value }),
        });
    },
    hashchange: (e, logger) => {
        void logger.log({
            eventName: 'URL_HASH_CHANGE',
            logData: Object.assign(Object.assign({}, getBrowserProps()), { oldUrl: e === null || e === void 0 ? void 0 : e.oldURL }),
        });
    },
});
//# sourceMappingURL=index.js.map